/**
 * Validate Create Game form.
 * @param {{ displayName: string | undefined | null }} input
 * @returns {{ displayName?: string }} errors object
 */
export function validateCreateForm({ displayName }) {
    const name = (displayName || '').trim();
    const errors = {};

    if (name.length === 0) {
        errors.displayName = 'Name is required.';
    }

    return errors;
}

/**
 * Validate Home Join form.
 * @param {{ displayName: string | undefined | null, gameCode: string | undefined | null }} input
 * @returns {{ displayName?: string, gameCode?: string }} errors object
 */
export function validateHomeJoinForm({ displayName, gameCode }) {
    const name = (displayName || '').trim();
    const code = (gameCode || '').trim();
    const errors = {};

    if (name.length === 0) {
        errors.displayName = 'Name is required.';
    }

    if (code.length === 0) {
        errors.gameCode = 'Game code is required.';
    } else if (code.length !== 6) {
        errors.gameCode = 'Game code must be 6 characters.';
    }

    return errors;
}
